const UserPreferencesConstants = {
  // Column specific
  SET_PREFERENCE: 'SR_USERPREFS_SET_PREFERENCE',
  GET_SUCCESS: 'SR_USERPREFS_GET_SUCCESS',
  CLEAR_SUCCESS: 'SR_USERPREFS_CLEAR_SUCCESS',
  CLEAR_FAILED: 'SR_USERPREFS_CLEAR_FAILED',

  // NOT USED, Defined for safety: prevent case matching for 'undefined'.
  RESET: 'NOT_USED_USERPREFS_RESET',
  GET: 'NOT_USED_USERPREFS_GET',
  GET_FAIL: 'NOT_USED_USERPREFS_GET_FAIL',
  GET_FOR_OPEN: 'NOT_USED_USERPREFS_GET_FOR_OPEN',
  GET_FOR_OPEN_SUCCESS: 'NOT_USED_USERPREFS_GET_FOR_OPEN_SUCCESS',
  GET_FOR_OPEN_FAIL: 'NOT_USED_USERPREFS_GET_FOR_OPEN_FAIL',
  SAVE: 'NOT_USED_USERPREFS_SAVE',
  SAVE_SUCCESS: 'NOT_USED_USERPREFS_SAVE_SUCCESS',
  SAVE_FAIL: 'NOT_USED_USERPREFS_SAVE_FAIL',
  REMOVE: 'NOT_USED_USERPREFS_REMOVE',
  REMOVE_SUCCESS: 'NOT_USED_USERPREFS_REMOVE_SUCCESS',
  REMOVE_FAIL: 'NOT_USED_USERPREFS_REMOVE_FAIL',
  CREATE: 'NOT_USED_USERPREFS_CREATE',
  OPEN: 'NOT_USED_USERPREFS_OPEN',
  OPEN_READONLY: 'NOT_USED_USERPREFS_OPEN_READONLY',
  MODIFY: 'NOT_USED_USERPREFS_MODIFY',
  RELOAD: 'NOT_USED_USERPREFS_RELOAD',
  SET_VISIBLE_RANGE: 'NOT_USED_USERPREFS_SET_VISIBLE_RANGE',
  SET_FILTER: 'NOT_USED_USERPREFS_SET_FILTER',
  SET_SORTORDER: 'NOT_USED_USERPREFS_SET_SORTORDER',
  SET_SELECTION: 'NOT_USED_USERPREFS_SET_SELECTION',
  MODIFY_SELECTION: 'NOT_USED_USERPREFS_MODIFY_SELECTION',
  ALLOW_MULTI_SELECT: 'NOT_USED_USERPREFS_ALLOW_MULTI_SELECT',
  ENSURE_SELECTION_IS_VISIBLE: 'NOT_USED_USERPREFS_ENSURE_SELECTION_IS_VISIBLE',
  FIND: 'NOT_USED_USERPREFS_FIND',
  FIND_SUCCESS: 'NOT_USED_USERPREFS_FIND_SUCCESS',
  FIND_FAIL: 'NOT_USED_USERPREFS_FIND_FAIL'
};

export default UserPreferencesConstants;
